module.exports = __webpack_public_path__ + "media/images/help-icon-1e70af5981d267c2669ffb83a978bd14.svg";